import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useSearchParams } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AppProvider } from "./context/AppContext";
import { ThemeProvider } from "./context/ThemeContext";
import Home from "./pages/Home";
import AllDestinations from "./pages/AllDestinations";
import SimDetails from "./pages/SimDetails";
import DestinationGroupPage from "./pages/DestinationGroupPage";
import Checkout from "./pages/Checkout";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import AdminDashboard from "./pages/AdminDashboard";
import AuthCallback from "./pages/AuthCallback";
import TopUp from "./pages/TopUp";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import DeleteAccount from "./pages/DeleteAccount";
import AccountSettings from "./pages/AccountSettings";
import SaveCard from "./pages/SaveCard";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import NotificationBanner from "./components/NotificationBanner";
import ReferralPopup from "./components/ReferralPopup";
import WelcomePopup from "./components/WelcomePopup";
import { bootstrapNativeShell } from "./lib/nativeShell";

function AppRouter() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  
  // Check for OAuth callback (code parameter with state=google or state=facebook)
  // This synchronous check prevents race conditions
  const code = searchParams.get('code');
  const state = searchParams.get('state');
  
  if (code && (state === 'google' || state === 'facebook')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      {/* Referral popup - shows when ?ref= param is in URL */}
      <NotificationBanner />
      <ReferralPopup />
      <WelcomePopup />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/destinations" element={<AllDestinations />} />
        <Route path="/destinations/group/:groupId" element={<DestinationGroupPage />} />
        <Route path="/destinations/:countryId" element={<SimDetails />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/checkout/success" element={<Checkout />} />
        <Route path="/topup/:iccid" element={<TopUp />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/account-settings" element={<AccountSettings />} />
        <Route path="/save-card" element={<SaveCard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ForgotPassword />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
      </Routes>
    </>
  );
}

function App() {
  // Fire once on app startup. On the web build this is a no-op.
  useEffect(() => {
    bootstrapNativeShell();
  }, []);

  return (
    <HelmetProvider>
      <ThemeProvider>
        <AppProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </AppProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
